import jQuery from 'jquery';
const $ = window.$ = window.jQuery = jQuery;
var imagesLoaded = require('imagesloaded');
var Masonry = require('masonry-layout');
const body = document.querySelector('body');
const menu = document.querySelector('.menu-icon');
const menuItems = document.querySelectorAll('.nav__list-item');

$(document).ready(function () {
	$('.hamburger').click(function () {
		$(this).toggleClass('is-active');
		$('#myNav').toggleClass('active');
		$('body').toggleClass('active');
	});

	$('.owl-carousel').owlCarousel({
		loop: true,
		nav: true,
		center: false,
		margin: 0,
		navText: [
			"<i class='fal fa-long-arrow-left'></i>",
			"<i class='fal fa-long-arrow-right'></i>",
		],
		responsive: {
			0: {
				items: 1,
			},
			1350: {
				items: 3,
			},
			1400: {
				items: 2,
			},
			1900: {
				items: 3,
				center: true,
			},
		},
	});
	$('.owl-carousel').on('initialized.owl.carousel', function (event) {
		$('.owl-nav').text(event.item.index + ' of ' + event.item.count);
	});


	

	imagesLoaded( '#container', function() {
		var msnry = new Masonry('.masonry', {
			itemSelector: '.masonry--item',
			columnWidth: '.masonry--item',
			horizontalOrder: true,
			percentPosition: true,
			fitWidth: true,
		});
	});
	  
	// const $container = $( '.masonry' );
	// $container.imagesLoaded(() => {
	// 	if($container.length){
	// 		$container.Masonry( {
	// 			itemSelector: '.masonry--item',
	// 			columnWidth: '.masonry--item',
	// 			horizontalOrder: true,
	// 			percentPosition: true,
	// 			fitWidth: true,
	// 		} );
	// 	}
	// });


}); // document ready


//VIDEO

// controls=0&loop=1&rel=0&showinfo=0&modestbranding=1&disablekb=1&enablejsapi=1&autoplay=1&playlist=EhVlbKEpeHI
var player;
window.onYouTubeIframeAPIReady = () => {
	console.log("onYouTubeIframeAPIReady");
	let idVideo = document.getElementById('player').dataset.video;
	player = new YT.Player("player", {
		videoId: idVideo,
		width: "100%",
		height: "100%",
		playerVars: {
			autoplay: 1,
			playsinline: 1,
			controls: 0,
			loop: 1,
			rel: 0,
			showinfo: 0,
			modestbranding: 1,
			disablekb: 1,
			enablejsapi: 1,
			playlist: idVideo
		},
		events: {
			onReady: function (event) {
				setTimeout(function () {
					document.getElementById("processingBg").style.opacity = "0";
				}, 800);
				event.target.mute();
				event.target.playVideo();
			}
		}
	});
};
var tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";

var firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);